 
import { createAction, props } from '@ngrx/store';

 
export const getToken = createAction('[Auth] Get Token');
export const getTokenSuccess = createAction('[Auth] Get Token Success', props<{ token: string }>());
export const getTokenFailure = createAction('[Auth] Get Token Failure', props<{ error: any }>());
export const clearToken = createAction('[Auth] Clear Token');
